import { clamp } from '../Math';
import { defaultValue } from '../helpers';
const defaultCameraTarget = {
    target: undefined,
    targetDistance: 250,
};
const target = (state = defaultCameraTarget, action) => {
    switch (action.type) {
        case 'SET_CAMERA_DISTANCE':
            return Object.assign(Object.assign({}, state), { targetDistance: action.distance });
        case 'SET_CAMERA_TARGET':
            return Object.assign(Object.assign({}, state), { target: action.target });
        case 'CAMERA_ZOOM_IN': {
            const amount = -defaultValue(action.multiplier, 1.0);
            return Object.assign(Object.assign({}, state), { targetDistance: zoomDistance(state.targetDistance, amount) });
        }
        case 'CAMERA_ZOOM_OUT': {
            const amount = defaultValue(action.multiplier, 1.0);
            return Object.assign(Object.assign({}, state), { targetDistance: zoomDistance(state.targetDistance, amount) });
        }
        default:
            return state;
    }
};
function zoomDistance(currentDistance, amount) {
    const kMinTargetDist = 50;
    const kMaxTargetDist = 1500000;
    const kMinZoomRate = 100.0;
    const kMaxZoomRate = 1000000.0;
    // Zoom slower when closer to target, much faster when in space
    const zoomFactor = 0.1;
    let zoomRate = (currentDistance - kMinTargetDist) * zoomFactor;
    zoomRate = clamp(zoomRate, kMinZoomRate, kMaxZoomRate);
    const zoomDist = zoomRate * amount;
    const newDist = clamp(currentDistance + zoomDist, kMinTargetDist, kMaxTargetDist);
    return newDist;
}
export default target;
